// @utils/date.ts

function fromYYYYMMDD(s: string): Date | null {
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const [, y, mo, d] = m;
  return new Date(Number(y), Number(mo) - 1, Number(d)); // local midnight
}

export function asDate(input?: Date | string | null | undefined): Date | null {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.valueOf()) ? null : input;

  // Prefer local-midnight parse for yyyy-mm-dd
  const d = fromYYYYMMDD(input);
  if (d) return d;

  // Fallback: last resort for full ISO strings with time/offset
  const z = new Date(input);
  return isNaN(z.valueOf()) ? null : z;
}

export function toISODate(input?: Date | string | null): string | null {
  const d = asDate(input);
  if (!d) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function removeTZDateOnly(input?: Date | string | null): Date {
  const d = asDate(input);
  if (!d) return new Date(NaN);

  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Reusable helper (lets tests spy on it) */
export function addDays(d: Date, n: number): Date {
  if (!(d instanceof Date) || isNaN(d.valueOf())) return new Date(NaN);
  // normalize to local midnight like your original
  const base = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  base.setDate(base.getDate() + n);
  return base;
}

export function atMidnight(d: Date) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}
export function snapToSunday(d: Date) {
  const x = atMidnight(d);
  x.setDate(x.getDate() - x.getDay()); // 0=Sun
  return x;
}
export function snapToSaturday(d: Date) {
  const x = atMidnight(d);
  x.setDate(x.getDate() + (6 - x.getDay())); // 6=Sat
  return x;
}
